module.exports = __webpack_public_path__ + "img/BRAVO_6.8fe66e8e.jpg";